import pproDetailsLocale from './en.json'

const en = {
  pproDetails: pproDetailsLocale,
}

export default en
